import request from '@/utils/request'

let IcpApi = {

  /*优惠券列表*/
  queryICP(data) {
    return request._post('/shop/plus.icp.icp/query', data);
  },
  /*上传设置模板变量*/
  apiDetail(data) {
    return request._get('/shop/plus.icp.icp/index', data);
  },
  /*保存上传设置*/
  editIcpApi(data) {
    return request._post('/shop/plus.icp.icp/index', data);
  },

  /*获取icp记录*/
  getRecordList(data) {
    return request._post('/shop/plus.icp.icp/getRecordList', data);
  },
}

export default IcpApi;



// WEBPACK FOOTER //
// ./src/api/icp.js